import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blocco-ruolo-manager',
  templateUrl: './blocco-ruolo-manager.component.html',
  styleUrls: ['./blocco-ruolo-manager.component.css']
})
export class BloccoRuoloManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/blocco-ruolo-manager/blocco-ruolo-manager.component.ts